export default {
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    FILE: 'FILE',
    LINK: 'LINK',
    DIGEST: 'DIGEST',
    ACTIVITY: 'ACTIVITY',
    LIVE_LESSON: 'LIVE_LESSON',
};

export const translatedResourceTypes = {
    VIDEO: 'Vídeo',
    AUDIO: 'Áudio',
    FILE: 'Arquivo',
    LINK: 'Link',
    DIGEST: 'Resenha',
    ACTIVITY: 'Atividade',
    LIVE_LESSON: 'Aula ao vivo',
};



// WEBPACK FOOTER //
// ./src/utils/resource-types.js